<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <router-link to="/dashboard" class="nav-link" :class="getRoute() === 'dashboard' ? 'active' : ''">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">DASHBOARD</span>
        </router-link>
      </li>
      <li class="mt-3 nav-item" v-if="CheckMember()">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 me-4">
          회원관리
        </h6>
      </li>
      <li class="nav-item" v-if="member =='Y'">
        <router-link to="/member" class="nav-link" :class="getRoute() === 'member' ? 'active' : ''">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">회원목록</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="organization =='Y'">
        <router-link to="/organization" class="nav-link" :class="getRoute() === 'organization' ? 'active' : ''">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">추천인 트리</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="tree =='Y'">
        <router-link to="/tree" class="nav-link" :class="getRoute() === 'tree' ? 'active' : ''">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="ni ni-credit-card text-success text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">후원인 트리</span>
        </router-link>
      </li>
      <li class="mt-3 nav-item" v-if="CheckSale()">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 me-4">
          매출관리
        </h6>
      </li>
      <li class="nav-item" v-if="sales =='Y'">
        <router-link to="/sales" class="nav-link" :class="getRoute() === 'sales' ? 'active' : ''">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">매출내역</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="extra =='Y'">
        <router-link to="/extra" class="nav-link" :class="getRoute() === 'extra' ? 'active' : ''">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="ni ni-credit-card text-success text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">수당내역</span>
        </router-link>
      </li>

      <!-- <li class="nav-item" v-if="statistics =='Y'">
        <router-link to="/statistics" class="nav-link" :class="getRoute() === 'statistics' ? 'active' : ''">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="ni ni-credit-card text-success text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">통계</span>
        </router-link>
      </li> -->
      <li class="mt-3 nav-item" v-if="CheckCoin()">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 me-4">
          코인 관리
        </h6>
      </li>
      <li class="nav-item" v-if="coin === 'Y'">
        <router-link to="/coin/list" class="nav-link" :class="getRoute() === 'coin/list' ? 'active' : ''">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="ni ni-bullet-list-67 text-info text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">코인 목록</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="coin =='Y'">
        <router-link to="/coin/send" class="nav-link" :class="getRoute() === 'coin/send' ? 'active' : ''">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="ni ni-bullet-list-67 text-info text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">코인 전송</span>
        </router-link>
        </li>
      <li class="mt-3 nav-item">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 me-4">
          정보
        </h6>
      </li>
      <li class="nav-item">
        <router-link to="/profile" class="nav-link" :class="getRoute() === 'profile' ? 'active' : ''">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="ni ni-circle-08 text-dark text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">내정보</span>
        </router-link>
      </li>
      <!--사이트 관리자 메뉴-->

      <li class="mt-3 nav-item" v-if="CheckMaster()">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 me-4">
          마스터 관리
        </h6>
      </li>
      <li class="nav-item" v-if="admin =='Y'">
        <router-link to="/admin" class="nav-link" :class="getRoute() === 'admin' ? 'active' : ''">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">관리자 목록</span>
        </router-link>
      </li>

      <li class="nav-item" v-if="site =='Y'">
        <router-link to="/site" class="nav-link" :class="getRoute() === 'site' ? 'active' : ''">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="ni ni-settings-gear-65 text-dark text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">사이트 설정</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="system =='Y'">
        <router-link to="/system" class="nav-link" :class="getRoute() === 'system' ? 'active' : ''">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="ni ni-settings-gear-65 text-dark text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">시스템 정보</span>
        </router-link>
      </li>
    </ul>
  </div>
  <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <a
      href="javascrit:void(0);"
      target="_blank"
      class="mb-3 btn btn-success btn-sm w-100"
      @click="Logout()"
      >로그아웃</a>
  </div>
</template>
<script>

export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "",
      controls: "",
      isActive: "active",
      auth :  this.$store.state.auth,
      member: this.$store.state.m_member,
      organization: this.$store.state.m_organization,
      sales: this.$store.state.m_sales,
      extra: this.$store.state.m_extra,
      tree: this.$store.state.m_tree,
      statistics: this.$store.state.m_statistics,
      coin_member: this.$store.state.m_coin_member,
      coin_admin: this.$store.state.m_coin_admin,
      coin: this.$store.state.m_coin,
      admin: this.$store.state.m_admin,
      site: this.$store.state.m_site,
      system : this.$store.state.m_system,
    };
  },
  components: {

  },
  methods: {
    CheckMember(){
      let count = 0;
      if(this.member =='Y'){
        count++;
      }

      if(this.organization =='Y'){
        count++;
      }

      if(count >0){
        return true;
      }else{
        return false;
      }

    },
    CheckSale(){
      let count = 0;
      if(this.sales =='Y'){
        count++;
      }

      if(this.extra =='Y'){
        count++;
      }

      if(this.tree =='Y'){
        count++;
      }

      if(this.statistics =='Y'){
        count++;
      }

      if(count >0){
        return true;
      }else{
        return false;
      }

    },
    CheckMaster(){
      let count = 0;
      if(this.admin =='Y'){
        count++;
      }

      if(this.site =='Y'){
        count++;
      }

      if(this.system =='Y'){
        count++;
      }

      if(count >0){
        return true;
      }else{
        return false;
      }

    },
    CheckCoin(){
      let count = 0;
      if(this.coin =='Y'){
        count++;
      }

      if(this.coin_member =='Y'){
        count++;
      }

      if(this.coin_admin =='Y'){
        count++;
      }

      if(count >0){
        return true;
      }else{
        return false;
      }

    },
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    getAdminRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1]+'/'+routeArr[2];
    },
    getMasterRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1]+'/'+routeArr[2];
    },
    Logout(){
      this.$store.dispatch('SETLOGOUT').then(
        ()=>{
          window.location.href="/login";
        }
      )
    }
  }
};
</script>
